import { kontrolaPredelavaService } from '../services/kontrolaPredelava.service';
import Vue from 'vue';

const state = {
    kontrolaPredelava: [],
    sezona:null,
    predelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,predelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPredelovalecID', predelovalecid)
      return kontrolaPredelavaService.load(sezona,predelovalecid)
            .then(
                kontrolaPredelava => {
                  commit('load', kontrolaPredelava);
                  if(makeEditable)
                  commit('makeEditable') 
                  return kontrolaPredelava;                   
                } 
                
            );
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  kontrolaPredelavaService.loadAll(sezona)
            .then(
                kontrolaPredelava => commit('load', kontrolaPredelava)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.kontrolaPredelava.sezona;
        let predelovalecid=this.state.kontrolaPredelava.predelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.kontrolaPredelava.kontrolaPredelava.forEach(item=>{
            item.sezona=sezona;
            item.predelovalecid=predelovalecid;
            console.log(item);
            if(item.jeaktivna){
              kontrolaPredelavaService.save(item)
               .then(
                kontrolaPredelava => {
                   Vue.set(item,'saved',true);
                     Vue.set(item,'id',kontrolaPredelava.id);
                     Vue.set(item,'jeaktivna',1);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             kontrolaPredelavaService.save(item).then(
                kontrolaPredelava => {
                 Vue.set(item,'saved',true);
                                      
                },
                error => {
                    console.log(error);
              Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, kontrolaPredelava) {

          if(kontrolaPredelava)
        state.kontrolaPredelava=kontrolaPredelava.map(k=>{
            k["datumkontrole"]=kendo.parseDate(k["datumkontrole"]) 
            return k;
        }
            );   

     
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.kontrolaPredelava.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.kontrolaPredelava.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.kontrolaPredelava.length;i++){
            let dateStr=state.kontrolaPredelava[i].veljavnostcertifikataod;
            if(dateStr)
                state.kontrolaPredelava[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.kontrolaPredelava[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.kontrolaPredelava[i], { inEdit: true });
            state.kontrolaPredelava.splice(i,1,updated);
        }
        

    },
    setPredelovalecID(state, item) {
        state.predelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.kontrolaPredelava.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.kontrolaPredelava.splice(index,1,updated);
            } else {
                let id = 1;
                state.kontrolaPredelava.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.kontrolaPredelava.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.kontrolaPredelava.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.kontrolaPredelava);
                state.kontrolaPredelava.splice(index, 1);
        
        //    return data[index];
        //state.kontrolaPredelava=data;

    },
    replace(state, kontrolaPredelava) {
        state.kontrolaPredelava = kontrolaPredelava;
    }
   
};

export const kontrolaPredelava = {
    namespaced: true,
    state,
    actions,
    mutations
};
